module.exports = __webpack_public_path__ + "static/media/PrivateIcon.2c640d19.svg";